module.exports = __webpack_public_path__ + "editIcon.png?d5422321c4f6feed4081891051f9a6b2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vis/dist/img/network/editIcon.png
// module id = 567
// module chunks = 0